export const FaqData = [


    {
        id:1,
        question : "What is included in the training programm?",
        answer : "Our programs include ; Technical training , Tactical training ,Physical conditioning ,Intra-zonal leagues & practice matches ,Monthly beach or hill training sessions ,Participation in external tournaments (for advanced levels)"
    },
    {
        id:2,
        question :"Do I need prior football experience to join?",
        answer : "No prior experience is necessary. We offer basic, development, and elite level training to suit beginners as well as advanced players."
    },
    {
        id:3,
        question : "Where is Outlast FC located",
        answer : "We are based in Chennai with multiple training venues across the city. Contact us to find the center closest to you."
    },
    {
        id:4,
        question : "How do I register my child for training?",
        answer : "You can register by contacting us through our website, phone, or visiting the nearest training center. We’ll guide you through the process."
    },
    {
        id:5,
        question : "What age groups do you train at Outlast FC ?",
        answer : "We offer training programs for children and youth typically between the ages of 5 to 16 years, categorized by skill level and age group."
    },
    {
        id:6,
        question :"Do you conduct matches or tournaments?",
        answer : "Yes! Players regularly participate in intra-zonal leagues, friendly matches, and external tournaments. Elite players represent us in top-level competitions."
    },
    {
        id:7,
        question :"What should players bring to training?",
        answer :"Players should wear sports attire, football shoes, and carry a water bottle. Shin guards are recommended for safety."
    }


]